import { FC, useEffect, useRef } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Model
import { RootState } from 'app/store';
// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { AppUiNotificationsActions } from 'app/store/AppUINotifications/AppUINotifications.slice';
// Selectors
import { selectPushAlert } from 'app/store/AppUINotifications/AppUINotifications.selectors';
// Mui
import { Alert, Typography } from '@mui/material';
// Components
import { Button } from './Mui';

type Props = {
  caseId?: number;
  type: 'labels' | 'notes';
  applyFunc?: () => void;
}

const CasePushAlert:FC<Props> = ({
  // Props
  caseId, type, applyFunc
}) => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const alert = useAppSelector((state:RootState) => selectPushAlert(state, {
    category: 'case',
    type
  }));
  
  const lastAlertRef = useRef(alert);

  useEffect(() => {
    lastAlertRef.current = alert;
  }, [alert]);

  useEffect(() => {
    return () => {
      if ( lastAlertRef.current ) dispatch(AppUiNotificationsActions.removePushAlert({
        category: 'case',
        type
      }));
    }
    // eslint-disable-next-line
  }, []);

  const handleClick = () => {
    dispatch(AppUiNotificationsActions.removePushAlert({
      category: 'case',
      type
    }));
  }

  const handleApply = () => {
    if ( applyFunc === undefined ) return;
      applyFunc();
      handleClick();
  }

  if ( !alert || caseId !== alert.caseId ) return null;
  return (
    <Alert
      sx={{ mb: 4, alignItems: 'center' }}
      color="warning"
      onClose={handleClick}
      action={applyFunc ? (
        <Button
          name="apply-changes"
          size="small"
          variant="contained"
          onClick={handleApply}
        >{t('buttons.applyChanges')}</Button>
      ) : undefined}
    >
      {alert.message}
      {type === 'labels' ? (
        <Typography component="span" sx={{ display: 'block', fontSize: '11px' }}>
          {t('form.helperText.pushAlertLabelsHint')}
        </Typography>
      ) : null}
    </Alert>
  )
}

export default CasePushAlert;
